import { ReactComponentManifest } from "web/entrypoints/common/setup";
// Components
import { InStockProductPage } from "web/react/pages/product/in-stock/in-stock-product-page/in-stock-product-page";
import { OutOfStockProductPage } from "web/react/pages/product/out-of-stock/out-of-stock-product-page/out-of-stock-product-page";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    OutOfStockProductPage: withRedux(OutOfStockProductPage),
    InStockProductPage: withRedux(InStockProductPage),
};

export default components;
